import {AvailableCourses} from "../learning-course/AvailableCourses";

export class PurchaseOption {
    static readonly BASIC_CHAT_TOKENS = new PurchaseOption('BASIC_CHAT_TOKENS', 10.99, {tokens: 100}, "100 Tokenów");
    static readonly REGULAR_CHAT_TOKENS = new PurchaseOption('REGULAR_CHAT_TOKENS', 59.99, {tokens: 600}, "600 Tokenów");
    static readonly ADVANCED_CHAT_TOKENS = new PurchaseOption('ADVANCED_CHAT_TOKENS', 147.99, {tokens: 1500}, "1500 Tokenów");

    static readonly SAAS_PRO_MONTHLY = new PurchaseOption('SAAS_PRO_MONTHLY', 99.00, {saasPro: 1}, "SaaS Pro - Miesięczny", true);
    static readonly SAAS_PRO_YEARLY = new PurchaseOption('SAAS_PRO_YEARLY', 990.00, {saasPro: 12}, "SaaS Pro - Roczny", true);

    static readonly SAAS_MAX_MONTHLY = new PurchaseOption('SAAS_MAX_MONTHLY', 249.00, {saasMax: 1}, "SaaS Max - Miesięczny", true);
    static readonly SAAS_MAX_YEARLY = new PurchaseOption('SAAS_MAX_YEARLY', 2490.00, {saasMax: 12}, "SaaS Max - Roczny", true);

    static readonly COURSE_KED_BASIC_ACCESS = new PurchaseOption('COURSE_KED_BASIC_ACCESS', 6000.00, {courseAccess: AvailableCourses.KED_V2}, "Dostęp do Kursu Efektywnego Działania");
    // Indirect public sales page at /oferta/kurs-efektywnego-dzialania — 6000 PLN, real email collected by Tpay.
    static readonly COURSE_KED_SALES_PAGE = new PurchaseOption('COURSE_KED_SALES_PAGE', 6000.00, {courseAccess: AvailableCourses.KED_V2}, "Dostęp do Kursu Efektywnego Działania 2.0");
    static readonly COURSE_KED_WEBINAR_BASIC = new PurchaseOption('COURSE_KED_WEBINAR_BASIC', 1999.00, {courseAccess: AvailableCourses.KED}, "Dostęp do Kursu Efektywnego Działania");
    static readonly COURSE_KED_WEBINAR = new PurchaseOption('COURSE_KED_WEBINAR', 1999.00, {
        courseAccess: AvailableCourses.KED_V2,
        saasPro: 12
    }, "Dostęp do Kursu Efektywnego Działania", false, true, 3, [AvailableCourses.KED_V2], [AvailableCourses.KED_V2]);
    static readonly COURSE_KED_V2_WEBINAR = new PurchaseOption('COURSE_KED_V2_WEBINAR', 1999.00, {courseAccess: AvailableCourses.KED_V2}, "Dostęp do Kursu Efektywnego Działania 2.0 dla całej rodziny", false, true, 3, [AvailableCourses.KED_V2], [AvailableCourses.KED_V2]);
    static readonly COURSE_KED_NEWSLETTER = new PurchaseOption('COURSE_KED_NEWSLETTER', 1999.00, {courseAccess: AvailableCourses.KED}, "Dostęp do Kursu Efektywnego Działania dla całej rodziny", false, true, 3, [AvailableCourses.KED], [AvailableCourses.KED]);
    static readonly COURSE_KED_RADS = new PurchaseOption('COURSE_KED_RADS', 1999.00, {courseAccess: AvailableCourses.KED}, "Dostęp do Kursu Efektywnego Działania dla całej rodziny", false, true, 3, [AvailableCourses.KED], [AvailableCourses.KED]);
    static readonly COURSE_KED_WEBINAR_SALES_PAGE = new PurchaseOption('COURSE_KED_WEBINAR_SALES_PAGE', 1999.00, {courseAccess: AvailableCourses.KED}, "Dostęp do Kursu Efektywnego Działania dla całej rodziny", false, true, 3, [AvailableCourses.KED], [AvailableCourses.KED]);
    static readonly COURSE_KED_FROM_PED_SALES_PAGE = new PurchaseOption('COURSE_KED_FROM_PED_SALES_PAGE', 1999.00, {courseAccess: AvailableCourses.KED}, "Dostęp do Kursu Efektywnego Działania");
    static readonly COURSE_KED_V2_REFERRAL = new PurchaseOption('COURSE_KED_V2_REFERRAL', 3000.00, {courseAccess: AvailableCourses.KED_V2}, "Dostęp do Kursu Efektywnego Działania 2.0");
    static readonly COURSE_KED_DISCOUNTED = new PurchaseOption('COURSE_KED_DISCOUNTED', 997.00, {courseAccess: AvailableCourses.KED}, "Dostęp do Kursu Efektywnego Działania dla całej rodziny", false, true, 3, [AvailableCourses.KED], [AvailableCourses.KED]);

    // Newsletter reoffer - KED V2 only for 1 child at 997 PLN (no parent bonus, no SaaS)
    static readonly COURSE_KED_V2_REOFFER = new PurchaseOption('COURSE_KED_V2_REOFFER', 997.00, {courseAccess: AvailableCourses.KED_V2}, "Dostęp do Kursu Efektywnego Działania 2.0", false, false, 1, [], [AvailableCourses.KED_V2]);

    // KED V1 Only - discounted offer without KED V2 access
    static readonly COURSE_KED_V1_ONLY = new PurchaseOption('COURSE_KED_V1_ONLY', 849.00, {courseAccess: AvailableCourses.KED}, "Kurs Efektywnego Działania dla całej rodziny", false, true, 3, [], [AvailableCourses.KED]);

    static readonly COURSE_PED = new PurchaseOption('COURSE_PED', 199.00, {courseAccess: AvailableCourses.PED}, "Dostęp do Podstaw Efektywnego Działania");

    // New ZN Course
    static readonly COURSE_ZN = new PurchaseOption('COURSE_ZN', 997.00, {courseAccess: AvailableCourses.ZN}, "Dostęp do Kursu Zrozumieć Nastolatka");
    static readonly COURSE_ZN_PARENT = new PurchaseOption('COURSE_ZN_PARENT', 499.00, {courseAccess: AvailableCourses.ZN}, "Dostęp do Kursu Zrozumieć Nastolatka (oferta dla rodziców)");

    // New KED+ZN Bundle for families
    static readonly COURSE_KED_ZN_BUNDLE = new PurchaseOption('COURSE_KED_ZN_BUNDLE', 2497.00, {
        courseAccess: AvailableCourses.KED_V2,
        saasPro: 12
    }, "Pakiet Kursów: Kurs Efektywnego Działania + Kurs Zrozumieć Nastolatka", false, true, 3, [AvailableCourses.ZN, AvailableCourses.KED_V2], [AvailableCourses.KED_V2]);

    // V2 webinar offer - includes ZN for parent at 1999 PLN (no bundle selection needed)
    static readonly COURSE_KED_WEBINAR_V2 = new PurchaseOption('COURSE_KED_WEBINAR_V2', 1999.00, {
        courseAccess: AvailableCourses.KED_V2,
        saasPro: 12
    }, "Dostęp do Kursu Efektywnego Działania", false, true, 3, [AvailableCourses.ZN, AvailableCourses.KED_V2], [AvailableCourses.KED_V2]);

    // Webinar V2 with ZN offer for variation B - parent gets ZN only, 1 child gets KED_V2 (no SaaS)
    // Used for webinar and after-webinar promo pages
    static readonly COURSE_KED_WEBINAR_V2_ZN = new PurchaseOption('COURSE_KED_WEBINAR_V2_ZN', 1999.00, {
        courseAccess: AvailableCourses.KED_V2
    }, "Kurs Efektywnego Działania dla dziecka + Zrozumieć Nastolatka dla rodzica", false, true, 1, [AvailableCourses.ZN], [AvailableCourses.KED_V2]);

    // V3 (webinar 25-04) — same shape as V2_ZN, but children get an onboarding meeting slot.
    // Used for webinar 25-04 and post-webinar sales pages tied to it.
    static readonly COURSE_KED_WEBINAR_V3_ZN = new PurchaseOption('COURSE_KED_WEBINAR_V3_ZN', 1999.00, {
        courseAccess: AvailableCourses.KED_V2
    }, "Kurs Efektywnego Działania dla dziecka + Zrozumieć Nastolatka dla rodzica", false, true, 1, [AvailableCourses.ZN], [AvailableCourses.KED_V2]);

    // Soft-promo webinar (26-05) variant — same product shape as V3_ZN (KED_V2 for 1 child,
    // ZN for parent, Calendly onboarding) at the 3 990 PLN price anchor for świadomi rodzice.
    // MUST exist in this shared file so `PurchaseOption.byKey('COURSE_KED_WEBINAR_4KA_V1')`
    // resolves on the frontend — otherwise the transaction lookup falls back to V2_ZN (1999)
    // and the buyer pays the wrong price for the wrong fulfillment.
    static readonly COURSE_KED_WEBINAR_4KA_V1 = new PurchaseOption('COURSE_KED_WEBINAR_4KA_V1', 3990.00, {
        courseAccess: AvailableCourses.KED_V2
    }, "Kurs Efektywnego Działania dla dziecka + Zrozumieć Nastolatka dla rodzica", false, true, 1, [AvailableCourses.ZN], [AvailableCourses.KED_V2]);

    // Newsletter page purchase option at /newsletter/kurs-efektywnego-dzialania (3000 PLN, no webinar discount)
    static readonly COURSE_KED_NEWSLETTER_V2_ZN = new PurchaseOption('COURSE_KED_NEWSLETTER_V2_ZN', 3000.00, {
        courseAccess: AvailableCourses.KED_V2
    }, "Kurs Efektywnego Działania dla dziecka + Zrozumieć Nastolatka dla rodzica", false, true, 1, [AvailableCourses.ZN], [AvailableCourses.KED_V2]);

    // Dzień Dziecka gift — KED_V2 only for 1 child, no parent ZN, onboarding meeting handled like V3_ZN.
    // Used at /newsletter/dzien-dziecka. Parent buys, child receives password setup link + Michał's
    // Calendly. No parent /start page (it's a gift, not a parental program).
    static readonly COURSE_KED_DZIEN_DZIECKA = new PurchaseOption('COURSE_KED_DZIEN_DZIECKA', 1999.00, {
        courseAccess: AvailableCourses.KED_V2
    }, "Kurs Efektywnego Działania 2.0 — prezent na Dzień Dziecka", false, false, 1, [], [AvailableCourses.KED_V2]);

    // New webinar pricing options
    static readonly COURSE_KED_WEBINAR_SS = new PurchaseOption('COURSE_KED_WEBINAR_SS', 1999.00, {courseAccess: AvailableCourses.KED}, "Pakiet Solidny Start - Dostęp do Kursu Efektywnego Działania (dla 1 dziecka)");
    static readonly COURSE_KED_ZN_BUNDLE_PW = new PurchaseOption('COURSE_KED_ZN_BUNDLE_PW', 2499.00, {courseAccess: AvailableCourses.KED}, "Pakiet Pełne Wsparcie - KED dla dzieci + ZN dla rodziców", false, true, 3, [AvailableCourses.ZN], [AvailableCourses.KED]);

    static readonly EXTRAORDINARY_MONTHLY_SUPPORT = new PurchaseOption('EXTRAORDINARY_MONTHLY_SUPPORT', 3000.00, {extraordinarySupport: 1}, "MISTRZOWSKIE Wsparcie");

    static readonly SAAS_LAUNCH_SPECIAL_OFFER = new PurchaseOption('SAAS_LAUNCH_SPECIAL_OFFER', 797.00, {
        saasPro: 12,
        courseAccess: AvailableCourses.PED
    }, "Pakiet Edukacja 2.0", false, false, 1, [AvailableCourses.ZN], [AvailableCourses.KED]);

    static readonly FAMILY_LAUNCH_OFFER = new PurchaseOption('FAMILY_LAUNCH_OFFER', 797.00, {
        saasPro: 12,
        courseAccess: AvailableCourses.PED
    }, "Pakiet Edukacja 2.0", false, true, 1, [AvailableCourses.ZN], [AvailableCourses.PED]);

    // Black Friday Special Offer
    static readonly BLACKFRIDAY_SPECIAL_OFFER = new PurchaseOption('BLACKFRIDAY_SPECIAL_OFFER', 997.00, {
        saasPro: 6,
        courseAccess: AvailableCourses.KED
    }, "Black Friday: KED dla rodziny + ZN dla rodzica + 6 mies. platformy", false, true, 3, [AvailableCourses.ZN, AvailableCourses.KED], [AvailableCourses.KED]);

    // Christmas Special Offer
    // English webinar purchase options (USD)
    static readonly COURSE_KED_EN_WEBINAR = new PurchaseOption('COURSE_KED_EN_WEBINAR', 997.00, {courseAccess: AvailableCourses.KED_V2}, "Effective Action System - Full Access");
    static readonly COURSE_KED_EN_WEBINAR_INSTALLMENT = new PurchaseOption('COURSE_KED_EN_WEBINAR_INSTALLMENT', 397.00, {courseAccess: AvailableCourses.KED_V2}, "Effective Action System - 3x Payment Plan");

    // EAS premium /system landing offer (no webinar opt-in required)
    static readonly COURSE_EAS_SYSTEM = new PurchaseOption('COURSE_EAS_SYSTEM', 2997.00, {courseAccess: AvailableCourses.KED_V2}, "Effective Action System - Full Access");
    static readonly COURSE_EAS_SYSTEM_INSTALLMENT = new PurchaseOption('COURSE_EAS_SYSTEM_INSTALLMENT', 1097.00, {courseAccess: AvailableCourses.KED_V2}, "Effective Action System - 3x Payment Plan");

    // KED V2 + ZN installment downsell (4x 599 PLN) - available after promo deadline expires
    static readonly COURSE_KED_WEBINAR_V2_ZN_INSTALLMENT = new PurchaseOption('COURSE_KED_WEBINAR_V2_ZN_INSTALLMENT', 599.00, {
        courseAccess: AvailableCourses.KED_V2
    }, "Kurs Efektywnego Działania + Zrozumieć Nastolatka - 4 raty", true, true, 1, [AvailableCourses.ZN], [AvailableCourses.KED_V2]);

    static readonly CHRISTMAS_SPECIAL_OFFER = new PurchaseOption('CHRISTMAS_SPECIAL_OFFER', 997.00, {
        saasPro: 6,
        courseAccess: AvailableCourses.KED
    }, "Świąteczna Promocja: KED dla rodziny + ZN dla rodzica + 6 mies. platformy", false, true, 3, [AvailableCourses.ZN, AvailableCourses.KED], [AvailableCourses.KED]);

    private constructor(
        private readonly key: string,
        public readonly price: number,
        public readonly item: TransactionItem,
        public readonly description: string,
        public readonly isSubscription: boolean = false,
        public readonly isForEntireFamily: boolean = false,
        public readonly maxChildren: number = 1,
        public readonly coursesForParent?: AvailableCourses[],
        public readonly coursesForChildren?: AvailableCourses[]
    ) {
    }

    toString() {
        return this.key
    }

    /**
     * Look up a static PurchaseOption by its key string. Used when the backend (e.g. webinar
     * config) returns just the key and we need the full instance — keeps purchase keys out of
     * the frontend's hard-coded list.
     */
    static byKey(key: string | undefined | null): PurchaseOption | undefined {
        if (!key) return undefined;
        const all = Object.values(PurchaseOption).filter((v): v is PurchaseOption => v instanceof PurchaseOption);
        return all.find(o => o.toString() === key);
    }
}

export interface TransactionItem {
    tokens?: number
    courseAccess?: AvailableCourses
    coachingSessions?: number
    extraordinarySupport?: number
    saasPro?: number
    saasMax?: number
}